import { AspectRatioType, aspectRatioMapping } from '../../utils/aspect-ratio';
import { generateSrc } from './generate-src';

export type GenerateSrcSetOptionsType = {
  aspectRatio: AspectRatioType;
  url: string;
  minWidth: number;
  maxHeight: number;
  interval: number;
  hasDarkeningLayer?: boolean;
  hasImageTransparency?: boolean;
  additionalUrlParameters?: Record<string, string>;
  omitAspectRatioInUrl?: boolean;
};

export const generateSrcSet = (options: GenerateSrcSetOptionsType): string => {
  const {
    maxHeight,
    minWidth,
    aspectRatio,
    interval,
    url,
    hasDarkeningLayer,
    hasImageTransparency,
    additionalUrlParameters,
    omitAspectRatioInUrl
  } = options;

  const numericAspectRatio = aspectRatioMapping[aspectRatio];
  const modifiedInterval = numericAspectRatio < 1 ? interval / 2 : interval;

  let srcSet = '';

  const maxWidth = maxHeight * numericAspectRatio;

  for (let width = minWidth; width <= maxWidth; width += modifiedInterval) {
    const height = Math.round(width / numericAspectRatio);

    srcSet += `${width === minWidth ? '' : ', '}${generateSrc({
      width,
      height,
      url,
      aspectRatio,
      hasDarkeningLayer,
      hasImageTransparency,
      additionalUrlParameters,
      omitAspectRatioInUrl
    })} ${width}w`;
  }

  return srcSet;
};
